import { render, staticRenderFns } from "./viewerSectionVideo.vue?vue&type=template&id=cc6ae486&scoped=true&"
import script from "./viewerSectionVideo.vue?vue&type=script&lang=js&"
export * from "./viewerSectionVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6ae486",
  null
  
)

export default component.exports